const _colorPellet = {
    mainColor: '#161616',
    selectedSidebarColor: '#777af2',
    "kolkata_ser*mainColor": '#4C7D74',
    "kolkata_ser*selectedSidebarColor": '#4C7D74'
}


export const COLOR_PALLATE = {
    mainColor: _colorPellet.mainColor,
    selectedSidebarColor: _colorPellet.selectedSidebarColor,
}